import Produtos from '@/components/EnbPainel/Produtos/Produtos.vue'
import RegisterProd from '@/components/EnbPainel/Produtos/Register/RegisterProd'
import CategoriasProd from '@/components/EnbPainel/Produtos/Categorias/CategoriasProd'
import EnbClients from '@/components/EnbPainel/Clients/EnbClients'
import RegisterClient from '@/components/EnbPainel/Clients/Register/RegisterClient'
import ClientView from '@/components/EnbPainel/Clients/ClientView'
import EnbPedidos from '@/components/EnbPainel/Pedidos/EnbPedido'
import PedidoView from '@/components/EnbPainel/Pedidos/PedidoView'
import EnbGift from '@/components/EnbPainel/Gift/EnbGift'
import GiftRegister from '@/components/EnbPainel/Gift/GiftRegister'
import EnbUser from '@/components/EnbPainel/User/EnbUser'
import UserRegister from '@/components/EnbPainel/User/UserRegister'
import EnbEstoque from '@/components/EnbPainel/Estoque/EnbEstoque'
import EnbPreference from '@/components/EnbPainel/Preferencia/EnbPreference'
import EnbPagamentos from '@/components/EnbPainel/Pagamentos/EnbPagamentos'
import EnbFrete from '@/components/EnbPainel/Frete/EnbFrete'
import EnbMarketing from '@/components/EnbPainel/Marketing/EnbMarketing'
import EnbMarketingGeral from '@/components/EnbPainel/Marketing/EnbMarketingGeral'
import EnbMarketingSeo from '@/components/EnbPainel/Marketing/EnbMarketingSeo'
import DashBoard from '@/components/EnbPainel/Dashboard/DashBoard'
import EnbModel01Themes from '@/components/EnbPainel/Preferencia/EnbModel01Themes'
import EnbModel03Themes from '@/components/EnbPainel/Preferencia/EnbModel03Themes'
import EnbPreferenceGeral from '@/components/EnbPainel/Preferencia/EnbPreferenceGeral'

export default [
  {
    path: '/painel',
    name: 'Dashboard',
    component: DashBoard
  },
  {
    path: '/painel/produtos',
    name: 'Produtos',
    component: Produtos
  },
  {
    path: '/painel/captacoes',
    name: 'Captações',
    component: Produtos
  },
  {
    path: '/painel/produtos/categorias',
    name: 'Categorias de produtos',
    component: CategoriasProd
  },
  {
    path: '/painel/captacoes/categorias',
    name: 'Categorias das captações',
    component: CategoriasProd
  },
  {
    path: '/painel/produtos/register',
    name: 'Adicionar produto',
    component: RegisterProd
  },
  {
    path: '/painel/captacoes/register',
    name: 'Adicionar Captação',
    component: RegisterProd
  },
  {
    path: '/painel/produtos/edit',
    name: 'Editar produto',
    component: RegisterProd
  },
  {
    path: '/painel/captacoes/edit',
    name: 'Editar Captação',
    component: RegisterProd
  },
  {
    path: '/painel/produtos/copy',
    name: 'Copiar produto',
    component: RegisterProd
  },
  {
    path: '/painel/captacoes/copy',
    name: 'Copiar Captação',
    component: RegisterProd
  },
  {
    path: '/painel/client',
    name: 'Clientes',
    component: EnbClients
  },
  {
    path: '/painel/client/register',
    name: 'Adicionar cliente',
    component: RegisterClient
  },
  {
    path: '/painel/client/edit',
    name: 'Editar cliente',
    component: RegisterClient
  },
  {
    path: '/painel/client/view',
    name: 'Cliente',
    component: ClientView
  },
  {
    path: '/painel/pedidos',
    name: 'Pedidos',
    component: EnbPedidos
  },
  {
    path: '/painel/pedidos/view',
    name: 'Pedido',
    component: PedidoView
  },
  {
    path: '/painel/gift',
    name: 'Cupons',
    component: EnbGift
  },
  {
    path: '/painel/gift/register',
    name: 'Cadastro de cupons',
    component: GiftRegister
  },
  {
    path: '/painel/gift/update',
    name: 'Editar cupom',
    component: GiftRegister
  },
  {
    path: '/painel/users',
    name: 'Usuários',
    component: EnbUser
  },
  {
    path: '/painel/users/register',
    name: 'Cadastro de usuário',
    component: UserRegister
  },
  {
    path: '/painel/user/edit',
    name: 'Editar usuário',
    component: UserRegister
  },
  {
    path: '/painel/stock',
    name: 'Gerenciamento de estoque',
    component: EnbEstoque
  },
  {
    path: '/painel/preference',
    name: 'Preferências',
    component: EnbPreference,
    children: [
      {
        path: '/painel/preference',
        component: EnbPreferenceGeral,
      },
      {
        path: '/painel/preference/theme1',
        component: EnbModel01Themes,
      },
      {
        path: '/painel/preference/theme3',
        component: EnbModel03Themes,
      }
    ]
  },
  {
    path: '/painel/payments',
    name: 'Formas de Pagamento',
    component: EnbPagamentos
  },
  {
    path: '/painel/frete',
    name: 'Cobrança do frete',
    component: EnbFrete
  },
  {
    path: '/painel/marketing',
    name: 'Marketing',
    component: EnbMarketing,
    children: [
      {
        path: '/painel/marketing',
        component: EnbMarketingGeral,
      },
      {
        path: '/painel/marketing/seo',
        component: EnbMarketingSeo,
      }
    ]
  }
]
